import OfferCard from "@/components/monetization/OfferCard";
import { useOffers } from "@/lib/monetization";

// "Identity verified" for a renter (shown after a request is sent: owners see
// verified renters' requests first) or a landlord (dashboard, after listing).
export default function IdentityOffer({ who, surface, context, className }: { who: "renter" | "landlord"; surface: string; context?: string; className?: string }) {
  const module = who === "renter" ? "verified_renter" : "verified_landlord";
  const { data } = useOffers([module], { surface });
  const offer = data?.offers.find((o) => o.module === module);
  if (!offer || offer.state !== "available") return null;
  return <div className={className}><OfferCard offer={offer} context={context} returnPath={`/verify?kind=${who}`} /></div>;
}
